import { useCallback } from 'react';

type TFunction = (str: string, options?: any) => string;

const useTranslation = (t: TFunction) => {
  const tC = useCallback(
    (str?: string, options?: any) => {
      const newStr = str ? t(str, options) : '';
      return newStr.charAt(0).toUpperCase() + newStr.slice(1);
    },
    [t],
  );

  const tCE = useCallback(
    (str?: string, options?: any) => {
      const newStr = str ? t(str, options) : '';
      return newStr.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1));
    },
    [t],
  );

  const tU = useCallback(
    (str?: string, options?: any) => {
      const newStr = str ? t(str, options) : '';
      return newStr.toUpperCase();
    },
    [t],
  );

  return { t, tC, tCE, tU };
};

export default useTranslation;
